import { parseColorChannels } from "./color.js";

/** Rec.709 luma of the gamma-encoded channels, in [0,1]. It's only for sorting palette colors;
    for WCAG luminance, see color.ts. */
export function relLuma(color: string): number {
  const [r, g, b] = parseColorChannels(color);
  return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
}

/** The palette indices `indices`, ordered dark to light by `relLuma`. */
export function lumaOrder(colors: readonly string[], indices: readonly number[]): number[] {
  const luma = (index: number): number => relLuma(colors[index] ?? "#000000");
  return indices.toSorted((a, b) => luma(a) - luma(b));
}
